module.exports = __webpack_public_path__ + "static/hey-c7e948d145620182b07dd4c9cba1178c.png";